import { createContext, useContext } from 'react'

import type { TBookingContext, TBookingContextDef, TBookingCart, TBookingData } from './booking.d'
import { TBookingGroup } from './booking'
import { newPetGroup, newContact } from './helper'

export const newCart = (): TBookingCart => ({
  total: 0,
  contact: newContact(),
  payment: {
    method: 'payNow',
  },
  checkInTime: '',
  checkOutTime: '',
  vet: {
    name: '',
    phone: '',
  },
  groups: [],
})
export const newStateData = (): TBookingData => ({
  offersAddOns: undefined,
  petsAddOns: undefined,
  offerAvailability: undefined,
  temperTestOffer: undefined,
  formHandler: undefined,
  serviceType: undefined,
  petProfiles: undefined,
})

export const initialState: TBookingContext = {
  kind: 'boarding',
  startDate: undefined,
  endDate: undefined,
  isValid: false,
  searchBarOpen: false,
  maxGroups: 4,
  closedDates: [],
  openDays: [],
  currentState: 'search',
  groups: [newPetGroup()] as TBookingGroup[],
  asyncAction: false,
  config: {
    theme: undefined,
    booking: undefined,
    serviceType: undefined,
    species: undefined,
    location: undefined,
  },
  cart: newCart(),
  data: newStateData(),
  confirmation: {
    groups: [],
  },
}

export const BookingContext = createContext<TBookingContextDef | null>(null)

export const useBookingContext = () => {
  const ctx = useContext(BookingContext)
  if (ctx === null) {
    throw new Error('useSessionContext must be used within a SessionProvider')
  }
  return ctx
}
